import { Banner } from "./Banner";
import { Body } from "./Body";
import dataHome from '../../utils/data-pages/data-home.json';

export function PageHome() {
    return (
        <section className="home">
            <div className="home__banner">
                {
                    dataHome.map((item, index) => (
                        <Banner
                            key={index}
                            data={item} />
                    ))
                }
            </div>
            <div className="home__body">
                {
                    dataHome.map((item, index) => (
                        <Body
                            key={index}
                            data={item} />
                    ))
                }
            </div>
        </section>
    );
}